import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import resourceGlobalService from "services/resourceGlobalService";
import orderService from "../../services/orderService";

export const useResourceGlobalPreview = (payload, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);
  return useQuery(
    ["resource-global", payload],
    () => resourceGlobalService.getPreview(payload),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.previewResource", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: "",
      select: response => {
        const { data } = response;
        return data || "";
      },
    }
  );
};

export const useDownloadResources = (onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);

  const downloadBase64Image = (base64Data, filename) => {
    const link = document.createElement("a");
    link.href = base64Data;
    link.download = filename;
    link.click();
  };

  return useMutation(resourceGlobalService.downloadResources, {
    retry: 0,
    onSuccess: (response, request) => {
      const data = response.data;
      downloadBase64Image(data, request.name);
      addToast(
        t("message.dowloadMultipleResources", {
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.dowloadMultipleResources", {
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDownloadMultipleResources = (onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);
  return useMutation(resourceGlobalService.downloadMultipleResources, {
    retry: 0,
    onSuccess: response => {
      const data = response.data;
      addToast(
        t("message.dowloadMultipleResources", {
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.dowloadMultipleResources", {
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteResource = (onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);
  return useMutation(resourceGlobalService.deleteResource, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;
      addToast(
        t("message.deleteResource", {
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.deleteResource", {
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteReminder = (onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["order"]);
  return useMutation(orderService.deleteOrderReminder, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;
      addToast(
        t("message.deleteResource", {
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.deleteResource", {
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
